import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getRoleLabel, getBlockModeLabel } from '../../helpers/user';
import {  
  Card,
  Button,
  Header,
  Label,
  Loader,
  Grid,
  Input,
  Icon,
  Confirm,  
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import { settingsActions } from '../../actions/settings.actions';
import { userConstants } from '../../constants/user.constants';

class WebhookIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {        
      search: null,
      users: null,
      confirmOpen: false,
      confirmAction: null,
      confirmWebhook: null,
      confirmMessage: null
    };
  }

  static get propTypes() { 
    return { 
        users: PropTypes.any,        
        confirmOpen: PropTypes.bool,
        confirmAction: PropTypes.string,
        confirmMessage: PropTypes.string,
        confirmWebhook: PropTypes.any,
        me: PropTypes.any,
        loading: PropTypes.bool,
    }; 
  }

  componentDidMount() {    
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchWebhooks();
    }, 500);

    this.fetchWebhooks();
  }

  fetchWebhooks() {
    const { dispatch } = this.props;         
    const { page, search } = this.state;
    dispatch(settingsActions.fetchWebhooks({ page, search }));
  }

  handleSearch(search) {    
    this.setState({ search, page: 1 });
    this.handleSearchDebounced();
  }

  handlePageChange(activePage) {      
    this.setState({ page: activePage }, () => this.fetchUsers());
  }

  showConfirm(webhook, action) {
    let msg = `Tem certeza que deseja remover o webhook ${webhook.Name}?`;
    if (action == 'unblock') {
      msg = `Tem certeza que deseja desbloquear o acesso do usuário ${webhook.Name}?`;
    }
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmWebhook: webhook,
      confirmMessage: msg
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmWebhook, confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(settingsActions.deleteWebhook(confirmWebhook.Id)).then(() => this.fetchWebhooks());
    }

    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmWebhook: null,
      confirmMessage: null
    });
  }

  goToCreate() {
    history.push('/settings/webhooks/create');
  }
  
  formatNotifications(webhook) {
    
    const notifications = [];
    if (webhook.NotifySettingsChanges) {
      notifications.push('configurações');
    }
    if (webhook.NotifyUsersChanges) {
      notifications.push('usuários');
    }
    if (webhook.NotifyAccessLogs) {
      notifications.push('logs acesso');
    }
    if (webhook.NotifyClockRegisters) {
      notifications.push('registros de ponto');
    }
    if (webhook.NotifyNotifications) {
      notifications.push('notifications');
    }
    if (webhook.NotifyRequests) {
      notifications.push('solicitações');
    }
    if (webhook.NotifyUserlock) {
      notifications.push('userlock');
    }
    return notifications.join(', ')
  }

  render() {    
    const { webhooks, loading, me } = this.props;        

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    return (
      <Fragment>
        <Loader active={loading}>Carregando...</Loader>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Webhooks</h1>   
        </Header>

        <Grid stackable columns='2'>
          <Grid.Row>            
            <Grid.Column textAlign='left' width={12}>
              <Input icon='search' fluid onChange={(e, data) => this.handleSearch(data.value)} placeholder='Procurar...' loading={loading} />
            </Grid.Column>

            { me && me.permissions.includes("user.update") &&
            <Grid.Column textAlign='right' width={4}>
              <Button color='primary' fluid onClick={this.goToCreate}>Novo Webhook</Button>
            </Grid.Column>}
          </Grid.Row>          
        </Grid>     
        
        <Card.Group>
          { (!webhooks || (webhooks.Results && webhooks.TotalNumberOfRecords == 0)) &&
            <Card header='Nenhum webhook' fluid />
          }

          { webhooks && webhooks.Results && webhooks.Results.map((webhook) => {           
            return <Card key={webhook.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {webhook.Name}                   
                  <Label style={{float: "right", marginRight: '4px'}} color={webhook.Enabled ? 'green' : 'red'}>
                    {webhook.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>                
                <Card.Description>
                  <p><strong>URL:</strong> {webhook.Url}</p>                                    
                  <p><strong>Notificações:</strong> {this.formatNotifications(webhook)}</p>
                </Card.Description>  
              </Card.Content>              
              <Card.Content extra>                
                  { me && me.permissions.includes("user.update") && <Button size='mini' secondary icon onClick={() => history.push(`/settings/webhooks/update/${webhook.Id}`) }>
                    <Icon name='edit' />
                    Alterar
                  </Button>}

                  { me && me.permissions.includes("user.remove") && <Button size='mini' color='red' icon onClick={() => this.showConfirm(webhook, 'remove') }>
                    <Icon name='cancel' />
                    Excluir
                  </Button>}                                     
              </Card.Content>          
            </Card>                      
          }) }
        </Card.Group>

        <PaginationContainer registers={webhooks} onPageChange={(e, { activePage }) => this.handlePageChange(activePage) } />        
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { settings, users } = state;      

  return { 
    webhooks: settings.webhooks || null,
    loading: settings.loading,
    me: users.me || null,
   };
}

const connectedWebhookIndexScreen = connect(mapStateToProps)(WebhookIndexScreen);
export { connectedWebhookIndexScreen as WebhookIndexScreen };
